import React from 'react';

const StreamCard = React.memo(({ stream, isSelected, onClick, listenerCount }) => {
  const formatBitrate = (bitrate) => {
    if (!bitrate || bitrate === 'Unknown') return '192k mp3';
    return `${bitrate} kbps`;
  };

  const formatMount = (mount) => {
    if (!mount) return 'Unknown';
    // Extract just the mount point from the full URL
    return mount.replace(/^https?:\/\/[^/]+/, '');
  };

  return (
    <div 
      className={`stream-card ${isSelected ? 'active' : ''}`}
      onClick={onClick}
    >
      <div className="stream-header">
        <div>
          <div className="stream-title">
            {stream.title || 'Untitled Stream'}
          </div>
          <div className="stream-mount">
            {formatMount(stream.mount)}
          </div>
        </div>
        <div className="listener-count">
          {listenerCount} active {listenerCount === 1 ? 'listener' : 'listeners'}
        </div>
      </div>

      <div className="stream-meta">
        <div className="meta-item">
          <span className="meta-label">Genre</span>
          <span className="meta-value">{stream.genre || 'Unknown'}</span>
        </div>
        <div className="meta-item">
          <span className="meta-label">Bitrate</span>
          <span className="meta-value">{formatBitrate(stream.bitrate)}</span>
        </div>
        <div className="meta-item">
          <span className="meta-label">Server</span>
          <span className="meta-value">{stream.server_name || 'Unknown'}</span>
        </div>
        <div className="meta-item">
          <span className="meta-label">Status</span>
          <span className="meta-value" style={{ color: listenerCount > 0 ? 'var(--accent-secondary)' : 'var(--text-muted)' }}>
            {listenerCount > 0 ? 'Active' : 'Idle'}
          </span>
        </div>
      </div>

      {stream.server_description && (
        <div style={{ marginTop: '1rem', fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
          {stream.server_description}
        </div>
      )}
    </div>
  );
});

StreamCard.displayName = 'StreamCard';

export default StreamCard;